import {datatables} from "../datatables";
export default function() {
  datatables();

  const payableRevenue = $.fn.dataTable.absoluteOrder([{
    value: '', position: 'bottom',
  }]);
  const listTableElement = $('#revenueListTable');
  listTableElement.DataTable({
    dom: 'Bfrtip',
    ordering: true,
    buttons: [
      'copy', 'csv', 'excel', 'pdf', 'print',
    ],
    language: {
      search: '_INPUT_',
      searchPlaceholder: window.Lang.get('general.search') + '...',
    },
    columnDefs: [
      {targets: listTableElement.find('th.revenue').index(), type: payableRevenue},
    ],
  });
};
